module.exports = __webpack_public_path__ + "img/winner-hours.05a1efec.png";